import { AxiosInstance } from "axios"

export enum Page {
    SETTINGS = "SETTINGS",
    PRODUCTION = "PRODUCTION",
    PRODUCTION_PLANNING = "PRODUCTION_PLANNING",
    PRODUCTION_MEETING_SERVICE = "PRODUCTION_MEETING_SERVICE",
    PRODUCTION_POS_PURCHASES = "PRODUCTION_POS_PURCHASES",
    PRODUCTION_ORDERS = "PRODUCTION_ORDERS",
    PRODUCTION_TAKE_AWAY = "PRODUCTION_TAKE_AWAY",
    PURCHASE_CONTROL = "PURCHASE_CONTROL",
    USER_SURVEY = "USER_SURVEY",
    ACCOUNTING_PRODUCT_SALES = "ACCOUNTING_PRODUCT_SALES",
    ACCOUNTING_ORDER = "ACCOUNTING_ORDER",
    ACCOUNTING_ORDERS = "ACCOUNTING_ORDERS",
    ACCOUNTING_CASH_REGISTER = "ACCOUNTING_CASH_REGISTER",
    ACCOUNTING_SUBSCRIPTIONS = "ACCOUNTING_SUBSCRIPTIONS",
    ACCOUNTING_BALANCE = "ACCOUNTING_BALANCE",
    ACCOUNTING_CUSTOMERS = "ACCOUNTING_CUSTOMERS",
    ACCOUNTING_CUSTOMER_BALANCE = "ACCOUNTING_CUSTOMER_BALANCE",
    ACCOUNTING_Z_REPORTS = "ACCOUNTING_Z_REPORTS",
    MERCHANT_CUSTOM_REPORTS = "MERCHANT_CUSTOM_REPORTS",
    MENU_PLANNING = "MENU_PLANNING",
    MESSAGES = "MESSAGES",
    MESSAGE_CREATE = "MESSAGE_CREATE",
    MESSAGE_EDIT = "MESSAGE_EDIT",
    MERCHANT_CUSTOMER_ACCESS = "MERCHANT_CUSTOMER_ACCESS",
    SUPPLIER_MERCHANT_ACCESS = "SUPPLIER_MERCHANT_ACCESS",
    SUPPLIER_MEETING_SERVICE = "SUPPLIER_MEETING_SERVICE",
    SUPPLIER_MERCHANT_SALES = "SUPPLIER_MERCHANT_SALES",
    SUPPLIER_GDPR = "SUPPLIER_GDPR",
    SUPPLIER_CUSTOMER_SALES = "SUPPLIER_CUSTOMER_SALES",
    SUPPLIER_ACCOUNTING_POS_ORDERS = "SUPPLIER_ACCOUNTING_POS_ORDERS",
    SUPPLIER_SUBSCRIPTIONS = "SUPPLIER_SUBSCRIPTIONS",
    SUPPLIER_Z_REPORTS = "SUPPLIER_Z_REPORTS",
    MERCHANT_ADMIN_DEVICES = "SUPPLIER_ADMIN_DEVICES",
    SUPPORT_ADMIN_DEVICES = "SUPPORT_ADMIN_DEVICES",
    SUPPORT_ADMIN_INVOICING_BASIS_FOR_INVOICING = "SUPPORT_ADMIN_INVOICING_BASIS_FOR_INVOICING",
    SUPPORT_ADMIN_SCHEDULER = "SUPPORT_ADMIN_SCHEDULER",
    SUPPORT_ADMIN_SCHEDULER_EDIT_JOB = "SUPPORT_ADMIN_SCHEDULER_EDIT_JOB",
    SUPPORT_ADMIN_HEALTH_SERVER_MEMORY = "SUPPORT_ADMIN_HEALTH_SERVER_MEMORY",
    SUPPORT_ADMIN_HEALTH_DATABASE_HEALTH = "SUPPORT_ADMIN_HEALTH_DATABASE_HEALTH",
    SUPPORT_ADMIN_HEALTH_ADYEN = "SUPPORT_ADMIN_HEALTH_ADYEN",
    SUPPORT_ADMIN_GDPR = "SUPPORT_ADMIN_GDPR",
    SUPPORT_MERCHANT_ACCESS = "SUPPORT_MERCHANT_ACCESS",
    SUPPORT_SUPPLIER_ACCESS = "SUPPORT_SUPPLIER_ACCESS",
    SUPPLIER_ADMIN_DEVICES = "SUPPLIER_ADMIN_DEVICES",
    SUPPLIER_ADMIN_ACQUIRING_FEES = "SUPPLIER_ADMIN_ACQUIRING_FEES",
    SUPPLIER_ADMIN_ACQUIRING_BANK_TRANSFERS = "SUPPLIER_ADMIN_ACQUIRING_BANK_TRANSFERS",
    SUPPLIER_ADMIN_BALANCE = "SUPPLIER_ADMIN_BALANCE",
    SUPPLIER_ADMIN_POS_SETTINGS = "SUPPLIER_ADMIN_POS_SETTINGS",
    SUPPLIER_ADMIN_POS_SETTINGS_CREATE = "SUPPLIER_ADMIN_POS_SETTINGS_CREATE",
    SUPPLIER_ADMIN_POS_SETTINGS_EDIT = "SUPPLIER_ADMIN_POS_SETTINGS_EDIT",
    SUPPLIER_POS = "SUPPLIER_POS",
    USER_ACCOUNT = "USER_ACCOUNT",
    SERVICE_CENTER_ACCOUNT = "SERVICE_CENTER_ACCOUNT",
    CHANGE_PASSWORD = "CHANGE_PASSWORD",
    SUPPLIER_MERCHANTS = "SUPPLIER_MERCHANTS",
    SUPPLIER_MERCHANTS_CREATE = "SUPPLIER_MERCHANTS_CREATE",
    SUPPLIER_MERCHANTS_EDIT = "SUPPLIER_MERCHANTS_EDIT",
    TENANT_PURCHASES = "TENANT_PURCHASES",
    TENANT_SUBSCRIPTIONS = "TENANT_SUBSCRIPTIONS",
    TENANT_USERS = "TENANT_USERS",
    TENANT_MEETING_SERVICE = "TENANT_MEETING_SERVICE",
    MERCHANT_USERS = "MERCHANT_USERS",
    SUPPLIER_ACCOUNT_ADMINISTRATORS = "SUPPLIER_ACCOUNT_ADMINISTRATORS",
    SUPPLIER_MERCHANT_ADMINISTRATORS = "SUPPLIER_MERCHANT_ADMINISTRATORS",
    SUPPLIER_TERMS_AND_CONDITIONS = "SUPPLIER_TERMS_AND_CONDITIONS",
    SUPPLIER_TERMS_AND_CONDITIONS_CREATE = "SUPPLIER_TERMS_AND_CONDITIONS_CREATE",
    SUPPLIER_TERMS_AND_CONDITIONS_UPDATE = "SUPPLIER_TERMS_AND_CONDITIONS_UPDATE",
    SUPPLIER_PRODUCTS_GROUPS_NUMBERS_LIST = "SUPPLIER_PRODUCTS_GROUPS_NUMBERS_LIST",
    SUPPLIER_PRODUCTS_GROUPS_NUMBERS_CREATE = "SUPPLIER_PRODUCTS_GROUPS_NUMBERS_CREATE",
    SUPPLIER_PRODUCTS_GROUPS_NUMBERS_UPDATE = "SUPPLIER_PRODUCTS_GROUPS_NUMBERS_UPDATE",
    TENANT_CREATE_USER = "TENANT_CREATE_USER",
    TENANT_CREATE_OFFICE_MANAGER = "TENANT_CREATE_OFFICE_MANAGER",
    MERCHANT_NEWS = "MERCHANT_NEWS",
    MERCHANT_NEWS_CREATE = "MERCHANT_NEWS_CREATE",
    MERCHANT_NEWS_EDIT = "MERCHANT_NEWS_EDIT",
    MERCHANT_PRICE_LIST = "MERCHANT_PRICE_LIST",
    MERCHANT_VAT_CODES_LIST = "MERCHANT_VAT_CODES_LIST",
    MERCHANT_CREATE_VAT_CODES_LIST = "MERCHANT_CREATE_VAT_CODES_LIST",
    MERCHANT_EDIT_VAT_CODES_LIST = "MERCHANT_EDIT_VAT_CODES_LIST",
    MERCHANT_CREATE_PRICE_LIST = "MERCHANT_CREATE_PRICE_LIST",
    MERCHANT_PRODUCT_GROUP = "MERCHANT_PRODUCT_GROUP",
    MERCHANT_PRODUCTS = "MERCHANT_PRODUCTS",
    MERCHANT_EXTRA_SERVICES = "MERCHANT_EXTRA_SERVICES",
    MERCHANT_ADMIN_SHOPS = "MERCHANT_ADMIN_SHOPS",
    MERCHANT_ADMIN_SHOPS_CREATE = "MERCHANT_ADMIN_SHOPS_CREATE",
    MERCHANT_ADMIN_SHOPS_EDIT = "MERCHANT_ADMIN_SHOPS_EDIT",
    MERCHANT_PAYMENT_LINKS = "MERCHANT_PAYMENT_LINKS",
    MERCHANT_PAYMENT_LINK_CREATE = "MERCHANT_PAYMENT_LINK_CREATE",
    MERCHANT_PAYMENT_LINK_EDIT = "MERCHANT_PAYMENT_LINK_EDIT",
    MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNTS = "MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNTS",
    MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNT_CREATE = "MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNT_CREATE",
    MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNT_EDIT = "MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNT_EDIT",
    MERCHANT_ADMIN_OFFERS = "MERCHANT_ADMIN_OFFERS",
    MERCHANT_ADMIN_DELIVERY_LOCATIONS = "MERCHANT_ADMIN_DELIVERY_LOCATIONS",
    MERCHANT_ADMIN_DELIVERY_LOCATION_CREATE = "MERCHANT_ADMIN_DELIVERY_LOCATION_CREATE",
    MERCHANT_ADMIN_DELIVERY_LOCATION_UPDATE = "MERCHANT_ADMIN_DELIVERY_LOCATION_UPDATE",
    MERCHANT_ID_CARDS = "MERCHANT_ID_CARDS",
    MERCHANT_ADMIN_SETTINGS_CUSTOM_JOBS = "MERCHANT_ADMIN_SETTINGS_CUSTOM_JOBS",
    MERCHANT_CREATE_ADMIN = "MERCHANT_CREATE_ADMIN",
    MERCHANT_UPDATE_ACCOUNT = "MERCHANT_UPDATE_ACCOUNT",
    SUPPLIER_CREATE_ADMIN = "SUPPLIER_CREATE_ADMIN",
    SUPPLIER_UPDATE_ACCOUNT = "SUPPLIER_UPDATE_ACCOUNT",
    SUPPLIER_CREATE_MERCHANT = "SUPPLIER_CREATE_MERCHANT",
    COMPANY_CREATE_ADMIN = "COMPANY_CREATE_ADMIN",
    SUPPORT_CREATE_ADMIN = "SUPPORT_CREATE_ADMIN",
    SUPPORT_CREATE_COMPANY = "SUPPORT_CREATE_COMPANY",
    SUPPORT_UPDATE_COMPANY = "SUPPORT_UPDATE_COMPANY",
    SUPPORT_ENTITIES = "SUPPORT_ENTITIES",
    SUPPORT_ADMIN_FEATURES = "SUPPORT_ADMIN_FEATURES",
    SUPPORT_ADMIN_FEATURES_EDIT = "SUPPORT_ADMIN_FEATURES_EDIT",
    SUPPORT_CREATE_SUPPLIER = "SUPPORT_CREATE_SUPPLIER",
    SUPPORT_UPDATE_SUPPLIER = "SUPPORT_UPDATE_SUPPLIER",
    SUPPORT_MESSAGES_EMAIL = "SUPPORT_MESSAGES_EMAIL",
    SUPPORT_PRINTER_QUEUE = "SUPPORT_PRINTER_QUEUE",
    SUPPORT_MESSAGES_SMS = "SUPPORT_MESSAGES_SMS",
    SUPPORT_ORDERS_POS = "SUPPORT_ORDERS_POS",
    SUPPORT_ACCOUNTING_SUBSCRIPTION = "SUPPORT_ACCOUNTING_SUBSCRIPTION",
    SUPPORT_ACCOUNTING_MEETING_SERVICE = "SUPPORT_ACCOUNTING_MEETING_SERVICE",
    SURVEYS_LIST = "SURVEYS_LIST",
    SURVEYS_LIST_CREATE = "SURVEYS_LIST_CREATE",
    SURVEYS_LIST_EDIT = "SURVEYS_LIST_EDIT",
    COMPANY_ADMIN_ORGANIZATION_LOCATIONS = "COMPANY_ADMIN_ORGANIZATION_LOCATIONS",
    COMPANY_ADMIN_ORGANIZATION_LOCATIONS_CREATE = "COMPANY_ADMIN_ORGANIZATION_LOCATIONS_CREATE",
    COMPANY_ADMIN_ORGANIZATION_LOCATIONS_EDIT = "COMPANY_ADMIN_ORGANIZATION_LOCATIONS_EDIT",
    COMPANY_MEETING_SERVICE = "COMPANY_MEETING_SERVICE",
    COMPANY_SUBSCRIPTIONS = "COMPANY_SUBSCRIPTIONS",
    COMPANY_ACCOUNTING_POS_ORDERS = "COMPANY_ACCOUNTING_POS_ORDERS",
    COMPANY_USERS = "COMPANY_USERS",
    COMPANY_USERS_CREATE_USER = "COMPANY_USERS_CREATE_USER",
    COMPANY_ADMINS = "COMPANY_ADMINS",
    COMPANY_ADMINS_GDPR = "COMPANY_ADMINS_GDPR",
    COMPANY_ADMINS_DATA_IMPORT_ID_CARDS = "COMPANY_ADMINS_DATA_IMPORT_ID_CARDS",
    COMPANY_ADMINS_DATA_IMPORT_ACCOUNT_NUMBERS = "COMPANY_ADMINS_DATA_IMPORT_ACCOUNT_NUMBERS",
    COMPANY_ADMINS_DATA_IMPORT_USERS = "COMPANY_ADMINS_DATA_IMPORT_USERS",
    COMPANY_ADMINS_DATA_IMPORT_BILL_RECEIVERS = "COMPANY_ADMINS_DATA_IMPORT_BILL_RECEIVERS",
    IMPORT_RESULT = "IMPORT_RESULT",
    COMPANY_ADMINS_CREATE_ADMIN = "COMPANY_ADMINS_CREATE_ADMIN",
    COMPANY_ACCOUNTING_BILL_RECEIVERS = "COMPANY_ACCOUNTING_BILL_RECEIVERS",
    COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS = "COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS",
    COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_CREATE = "COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_CREATE",
    COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_EDIT = "COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_EDIT",
    COMPANY_ADMIN_ORGANIZATION_USER_GROUPS = "COMPANY_ADMIN_ORGANIZATION_USER_GROUPS",
    COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_CREATE = "COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_CREATE",
    COMPANY_ADMIN_SETTINGS_CUSTOM_JOBS = "COMPANY_ADMIN_SETTINGS_CUSTOM_JOBS",
    COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_EDIT = "COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_EDIT",
    USER_UPCOMING_ORDERS = "UPCOMING_ORDERS_PURCHASES",
    USER_ARCHIVE = "USER_ARCHIVE",
    USER_ARCHIVE_MEETING_SERVICE = "USER_ARCHIVE_MEETING_SERVICE",
    USER_SETTINGS = "USER_SETTINGS",
    USER_SETTINGS_WALLETS = "USER_SETTINGS_WALLETS",
    USER_WALLETS_REFILL = "USER_WALLETS_REFILL",
    USER_EDIT_BILL_RECEIVER = "USER_EDIT_BILL_RECEIVER",
    USER_NEWS = "USER_NEWS",
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE = "SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE",
    SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE = "SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE",
    SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_CREATE_ROUTE = "SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_CREATE_ROUTE",
    SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_EDIT_ROUTE = "SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_EDIT_ROUTE",
    SERVICE_CENTER_REPORTS_MEETING_SERVICE_ROUTE = "SERVICE_CENTER_REPORTS_MEETING_SERVICE_ROUTE",
    SERVICE_CENTER_REPORTS_GUESTS_ROUTE = "SERVICE_CENTER_REPORTS_GUESTS_ROUTE",
    SERVICE_CENTER_ADMIN_ACCOUNT_ADMINS_ROUTE = "SERVICE_CENTER_ADMIN_ACCOUNT_ADMINS_ROUTE",
    SERVICE_CENTER_ADMIN_ACCOUNT_CREATE_ADMINS_ROUTE = "SERVICE_CENTER_ADMIN_ACCOUNT_CREATE_ADMINS_ROUTE",
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_ROOM_ROUTE = "SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_ROOM_ROUTE",
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_EDIT_ROOM_ROUTE = "SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_CAR_ROUTE",
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_CAR_ROUTE = "SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_ROOM_ROUTE",
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_EDIT_CAR_ROUTE = "SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_EDIT_CAR_ROUTE",
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_MOBILE_AV_ROUTE = "SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_MOBILE_AV_ROUTE",
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_EDIT_MOBILE_AV_ROUTE = "SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_EDIT_MOBILE_AV_ROUTE",
    SERVICE_CENTER_STATISTICS_ROUTE = "SERVICE_CENTER_STATISTICS_ROUTE",
    SERVICE_CENTER_ADMIN_ORGANIZATION_MANAGE_BOOKINGS_ROUTE = "SERVICE_CENTER_ADMIN_ORGANIZATION_MANAGE_BOOKINGS_ROUTE",
    SERVICE_CENTER_REMINDERS_ROUTE = "SERVICE_CENTER_REMINDERS_ROUTE",
}

export enum PageHelpStatus {
    NEW = "NEW",
    BETA = "BETA",
    MAINTENANCE = "MAINTENANCE",
}

export type PageHelpContent = Readonly<{
    pageHelp: {
        title: string
        text: string
        helpGuides: {
            title: string
            url: string
        }[]
        status?: PageHelpStatus
    }
}>

type FetchPageHelpContentParams = Readonly<{
    page: Page
}>

export async function fetchPageHelpContent(
    { page }: FetchPageHelpContentParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<PageHelpContent> {
    const url = `page/help?page=${page.toUpperCase()}`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}
